// extracted by mini-css-extract-plugin
export default {"container":"AboutPage_container__t50ZY","heading":"AboutPage_heading__dmJFk","subheading":"AboutPage_subheading__fslhX","content":"AboutPage_content__nizHi"};